<template>
<div class="inustryHazard_container">
    <div v-for="(item, index) in categoryData" :key="index">
      
        <div class="title">
            <span>{{item.abbreviationCategory}}-{{item.fullCategory}}</span>
        </div>
        <div class="inustryHazard_body" >
              <div v-if="item.abbreviationCategory != '专篇'&& item.abbreviationCategory != '预评'">
               <a-button type="primary" @click="addPost(index)" > 新增岗位 </a-button>
               <div class="inustryHazard_top">
                  <a-table :data-source="item.postData" bordered :pagination="false">
						<a-table-column key="index" title="序号" data-index="index">
							<template scope="text, record, index">{{ index+1 }}</template>
						</a-table-column>
						<a-table-column key="postName" title="岗位" ellipsis="true" data-index="postName" />
						<a-table-column key="val" title="检测项目" ellipsis="true" data-index="val" >
                            <template slot-scope="val">
                                <span v-for="item1 in val" :key="item1">{{ item1.factorName }} {{  }}</span>
							</template>
                        </a-table-column>
                        <a-table-column key="price" title="价格" ellipsis="true" data-index="price" />
						<a-table-column title="操作" data-index="is_inspected">
							<template scope="text,record,index">
								<a @click="editPost(index,record)">编辑</a>
							</template>
						</a-table-column>
                  </a-table>
                </div>
        </div>
        <div>
             <a-form-model :model="item.costList" :rules="rules" ref="costRef" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              :label-col="{ span: 9 }"
              class="model_span_form"
              :wrapper-col="{ span: 15 }"
              label="检测费"
              prop="testExpense"
            >
              <!-- <span>{{ item.costList.testExpense }}</span> -->
               <a-input v-model="item.costList.testExpense" @change="changeTotal(index)" :disabled="item.costList.testCharge <= 30000"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              :label-col="{ span: 9 }"
              class="model_span_form"
              :wrapper-col="{ span: 15 }"
              label="报告编制费"
              prop="reportFabrication"
            >
             <a-input v-model="item.costList.reportFabrication" placeholder="请输入" @change="changeTotal(index)"></a-input>
            </a-form-model-item>
          </a-col>
             <a-col :span="8">
            <a-form-model-item
              :label-col="{ span: 9 }"
              class="model_span_form"
              :wrapper-col="{ span: 15 }"
              label="专家评审费"
              prop="expertEvaluation"
            >
              <a-input v-model="item.costList.expertEvaluation" placeholder="请输入" @change="changeTotal(index)"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
         <a-col :span="8">
            <a-form-model-item
              :label-col="{ span: 9 }"
              class="model_span_form"
              :wrapper-col="{ span: 15 }"
              label="合计"
              prop="total"
            >
             <a-input v-model="item.costList.total"></a-input>
            <!-- <span>{{item.costList.total}}</span> -->
            </a-form-model-item>
          </a-col>
        </a-row>
         </a-form-model>


        </div>
            
        </div>
      
    </div>
    <!-- <span>{{propRowData}}</span> -->
    <AddPost :multiple="multiple" :UUID="UUID" :industryId="industryId" :postList="postList" :addPostVisible="addPostVisible" @addVisibleState="addVisibleState" :propRowData="propRowData" :categoryData1="categoryData1"
     @postDataList="postDataList"></AddPost>
      <EditPost :id="id" :rowInforMation="rowInforMation" :multiple="multiple" :UUID="UUID" :postList="postList" :editPostVisible="editPostVisible" @editVisibleState="editVisibleState" :propRowData="propRowData" :categoryData2="categoryData2"
     @postDataList="postDataList1" :edit="edit"></EditPost>
</div>
    
</template>
<script>
// import { defineComponent } from '@vue/composition-api'
import { postInfo_list} from '@/api/Industry'
import AddPost from '../components/addPost.vue'
import EditPost from '../components/editPost.vue'

export default {
     components: {
           AddPost,
           EditPost

      },
      //岗位列表postList
       props: ['categoryData',
      //  'postList',
       'propRowData',
       'UUID',
       'industryId'],

    data() {
        return {
          edit: 0,
          categoryData1: {},
          categoryData2: {},
          postList: [],
            id: '',
            editPostVisible: false,
            rowInforMation: '',
            multiple: '',
            list: [],
            index: '',
            postListData: [],
            val: [],
            postData: [],
            costList: [],
            //新增岗位弹窗
            addPostVisible: false,
        }
    },
    created() {
         
         console.log(this.categoryData, 'categoryData++++++++++++++++++++++++++++++++++++++++')
    },
    methods: {
        changeTotal(index){
            // (原数组, 索引值, 需要赋的值)
            let list =  JSON.parse(JSON.stringify( this.categoryData[index]))
            var a =  list.costList.testExpense
            var b =  list.costList.reportFabrication
            var c =  list.costList.expertEvaluation
            var d = Number(a) + Number(b) + Number(c)
            list.costList.total = d
              Object.assign(list,{
             postData: this.categoryData[index].postData,
             subId: this.categoryData[index].id

           })
            this.categoryData.splice(index,1,list)
            this.$emit('getcostList',this.categoryData )
            console.log(d, 'this.categoryData[index].costList.total')
            console.log(this.categoryData, 'this.categoryData===========================')


        },
        editPost(index,record) {
          
          this.editPostVisible = true
          this.rowInforMation = record
          console.log(record, 'record4444444444444444444444')
          this.id = index
                   postInfo_list({
                    sheetId: this.UUID,
                    industryId: this.industryId,
                    subId: this.categoryData[this.index].id
                    }).then(res => {
                      this.categoryData2 = this.categoryData[this.index]
        this.postList = res.data
        console.log(this.postList, 'this.postList333333333333333333')
        // res.data.forEach(item => {
        //   postInfo_details(item.id).then(res => {
        //     console.log(res, 'res444444444444444444444444')

        //   })
        // })

      })



            console.log(index,record,'index,record==========================')

        },
           postDataList1(data) {
            var postListData = []
            var val = []
            postListData.price = 0
            // this.postData = data.val
            val = data.val 
            var num = 0
            postListData.price = ''
            if (this.categoryData[this.index].abbreviationCategory == '检评') {
                for (var i=0;i<val.length; i++) {
                            num = num + val[i].price * data.pointNumber*3
                }
                postListData.price = num
            }else if (this.categoryData[this.index].abbreviationCategory == '现状' || this.categoryData[this.index].abbreviationCategory == '控评') {
                for (var i=0;i<val.length; i++) {
                            num = num + val[i].price * data.pointNumber*9
                }
                postListData.price = num
            }
            postListData.postName = data.postName
            console.log(data.val, 'postListData.val9999999999999999999999999999999999')
            postListData.val = data.val
          
              console.log('1111111111111111111111111111111')
              for (var i=0; i<this.categoryData[this.index].postData.length; i++) {
                if (this.id == i) {
               this.categoryData[this.index].postData[this.id] = postListData
               this.edit = 0
             }

              }
    
              var numb = 0
              this.categoryData[this.index].postData.forEach(item => {
                  numb = numb + item.price
                  
              })
            //   Object.assign(  this.categoryData[this.index],{costList: this.costList})
              this.categoryData[this.index].costList.testExpense= numb
              Object.assign( this.categoryData[this.index].costList,{testCharge: numb})
              this.categoryData[this.index].costList.total= numb
              console.log(numb, 'numb==============')
              console.log(this.categoryData[this.index].costList.testExpense, 'this.categoryData[this.index].costList.price==============')

            
        },
        
        postDataList(data) {
            var postListData = []
            var val = []
            postListData.price = 0
            // this.postData = data.val
            val = data.val 
            var num = 0
            postListData.price = ''
            if (this.categoryData[this.index].abbreviationCategory == '检评') {
                for (var i=0;i<val.length; i++) {
                            num = num + val[i].price * data.pointNumber*3
                }
                postListData.price = num
            }else if (this.categoryData[this.index].abbreviationCategory == '现状' || this.categoryData[this.index].abbreviationCategory == '控评') {
                for (var i=0;i<val.length; i++) {
                            num = num + val[i].price * data.pointNumber*9
                }
                postListData.price = num
            }
            postListData.postName = data.postName
            console.log(data.val, 'postListData.val9999999999999999999999999999999999')
            postListData.val = data.val
           
              console.log('2222222222222222222222222222222')
                this.categoryData[this.index].postData.push(postListData)

           
              var numb = 0
              this.categoryData[this.index].postData.forEach(item => {
                  numb = numb + item.price
                  
              })
            //   Object.assign(  this.categoryData[this.index],{costList: this.costList})
              this.categoryData[this.index].costList.testExpense= numb
              Object.assign( this.categoryData[this.index].costList,{testCharge: numb})
              this.categoryData[this.index].costList.total= numb
              console.log(numb, 'numb==============')
              console.log(this.categoryData[this.index].costList.testExpense, 'this.categoryData[this.index].costList.price==============')

            
        },
        addPost(index) {

          console.log(this.categoryData, 'categoryData===========================')
          
            this.addPostVisible = true
             this.index = ''
            
            this.index = index
            console.log(this.index, 'this.index')
             if (this.categoryData[this.index].abbreviationCategory == '检评') {
                 this.multiple = 3
             } else {
                 this.multiple = 9
             }
              postInfo_list({
                sheetId: this.UUID,
               industryId: this.industryId,
               subId: this.categoryData[this.index].id,
        }).then(res => {
          this.categoryData1 = this.categoryData[this.index]
          console.log(this.categoryData1, 'this.categoryData1=====================s')

        this.postList = res.data
        console.log(this.postList, 'this.postList333333333333333333')
        // res.data.forEach(item => {
        //   postInfo_details(item.id).then(res => {
        //     console.log(res, 'res444444444444444444444444')

        //   })
        // })

      })
           
            




        },
        addVisibleState(data) {
            this.addPostVisible = data

        },
        editVisibleState(data){
              this.editPostVisible = data

        }
    }
   
}
</script>
<style>
.inustryHazard_body {
    background-color: #ffffff;
    padding: 15px 10px 10px;
    margin: 10px;

}
.inustryHazard_top {
    margin-top: 15px;

}
.title {
    font-size: 18px;
    padding: 5px 10px;
}
.inustryHazard_body {
  background-color: #fff;
  padding: 15px 5px;
  border-radius: 10px;
  padding-left: 10px;
}
.ant-form .ant-form-horizontal {
    background-color: #fff;
}

</style>
